<template>
  <nav class="category-links level">
    <!-- Left side -->
    <div v-if="!hiddenCategory" class="level-left">
      <p class="level-item"><strong>カテゴリー</strong></p>
      <p
        v-for="cat in $t('categories_q_a')"
        :key="cat.value"
        class="level-item"
      >
        <router-link :to="{ name: 'QACategory', params: { id: cat.value } }">{{ cat.name }}</router-link>
      </p>
    </div>
    <div v-else class="level-left"></div>

    <!-- Right side -->
    <div class="level-right">
      <div class="level-item">
        <img :src="require('@/assets/images/icons/icon-user.svg')" alt="" class="mr-4">
        <router-link :to="{ name: 'QAMyQuestions' }">
          <span>自分の質問を確認</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'QACategories',
  components: {},
  props: {
    hiddenCategory: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {};
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbs[pRouteTo].link) this.$router.push(this.breadcrumbs[pRouteTo].link);
    }
  }
};
</script>
